/**
 * @see https://umijs.org/docs/max/access#access
 * v1.1 角色体系重构：LEADER 已废弃，改为 PURCHASER / PRINCIPAL / GENERAL_MANAGER
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  // 检查用户是否有指定角色
  const hasRole = (roleName: string): boolean => {
    if (!currentUser) return false;

    // 检查 roles_text 数组
    if (currentUser.roles_text && Array.isArray(currentUser.roles_text)) {
      return currentUser.roles_text.includes(roleName);
    }

    // 兼容旧的 access 字段
    if (currentUser.access === 'admin' && roleName === 'ADMIN') {
      return true;
    }

    return false;
  };

  const isAdmin = hasRole('ADMIN') || hasRole('管理员');
  const isPrincipal = hasRole('PRINCIPAL') || hasRole('校区负责人');
  const isGeneralManager = hasRole('GENERAL_MANAGER') || hasRole('总经理');
  const isPurchaser = hasRole('PURCHASER') || hasRole('采购');
  const isWarehouseManager = hasRole('WAREHOUSE_MANAGER') || hasRole('库管');
  const isTeacher = hasRole('TEACHER') || hasRole('教师');

  // 审批人：校区负责人、总经理、管理员均具有审批权限
  const isApprover = isPrincipal || isGeneralManager || isAdmin;

  return {
    canAdmin: isAdmin,
    // 教务管理权限：校区负责人或管理员可以编辑（v1.1：原 Leader 的教务编辑权下沉到 Principal）
    canEditEducation: isPrincipal || isAdmin,
    // 教务管理权限：仅 Admin 可以删除
    canDeleteEducation: isAdmin,
    // 采购与库存管理权限：库管或 Admin 可访问
    canWarehouseManager: isWarehouseManager || isAdmin,
    // 采购工作台可见：库管、采购、审批人与管理员共享申购单链路
    canWarehouseWorkbench: isWarehouseManager || isPurchaser || isApprover || isAdmin,
    canViewInventory:
      isTeacher || isWarehouseManager || isPrincipal || isGeneralManager || isAdmin,
    canWarehouseMutate: isWarehouseManager || isAdmin,
    // 采购权限：采购员或 Admin
    canPurchase: isPurchaser || isAdmin,
    // 审批权限：校区负责人、总经理、管理员
    canApprove: isApprover,
    canUsePurchaseOrders:
      isTeacher || isWarehouseManager || isPurchaser || isApprover || isAdmin,
    // v1.2 WP-H：Principal / 总经理 只读看板，与 canApprove 同口径
    canViewReadonlyBoard: isApprover,
    // 细分角色标识（供页面按角色定制 UI）
    isPrincipal,
    isGeneralManager,
    isPurchaser,
    isTeacher,
  };
}
